import React from "react";
import { Zap } from "lucide-react";
import { PHONE, EMAIL, LOCATION, WHATSAPP_LINK } from "@/lib/constants";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="footer"
      className="relative bg-[#0a0a0a] border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16">
        <div className="grid lg:grid-cols-12 gap-10 mb-12">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3 mb-6">
              <span className="relative w-10 h-10 grid place-items-center bg-[#ff6b00] text-black">
                <Zap className="w-5 h-5" strokeWidth={2.5} />
              </span>
              <div className="leading-tight">
                <div className="font-display text-base font-bold">
                  TRANSFORMADORES BUCARAMANGA
                </div>
                <div className="text-[10px] uppercase tracking-[0.25em] text-[#a0aabf]">
                  La energía que no se detiene
                </div>
              </div>
            </div>
            <p className="text-[#a0aabf] text-sm leading-relaxed max-w-md">
              Más de 20 años brindando soluciones confiables en mantenimiento,
              reparación y venta de transformadores eléctricos para industria,
              comercio y distribución en Santander y toda Colombia.
            </p>
          </div>

          <div className="lg:col-span-2">
            <div className="text-[10px] uppercase tracking-[0.3em] text-[#ff6b00] mb-4">
              Navegación
            </div>
            <ul className="space-y-3 text-sm text-[#a0aabf]">
              {[
                ["#servicios", "Servicios"],
                ["#cotizador", "Cotizador"],
                ["#proceso", "Proceso"],
                ["#equipo", "Equipo"],
                ["#contacto", "Contacto"],
              ].map(([h, l]) => (
                <li key={h}>
                  <a
                    href={h}
                    className="hover:text-white transition-colors"
                    data-testid={`footer-link-${l.toLowerCase()}`}
                  >
                    {l}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <div className="text-[10px] uppercase tracking-[0.3em] text-[#ff6b00] mb-4">
              Servicios
            </div>
            <ul className="space-y-3 text-sm text-[#a0aabf]">
              <li>Venta de Transformadores</li>
              <li>Reparación Especializada</li>
              <li>Mantenimiento Preventivo</li>
              <li>Pruebas Eléctricas</li>
              <li>Emergencias 24/7</li>
            </ul>
          </div>

          <div className="lg:col-span-3">
            <div className="text-[10px] uppercase tracking-[0.3em] text-[#ff6b00] mb-4">
              Contacto
            </div>
            <ul className="space-y-3 text-sm text-[#a0aabf]">
              <li>
                <a
                  href={`tel:${PHONE.replace(/\s/g, "")}`}
                  className="hover:text-white"
                  data-testid="footer-phone"
                >
                  {PHONE}
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${EMAIL}`}
                  className="hover:text-white break-words"
                  data-testid="footer-email"
                >
                  {EMAIL.replace("@", "@​")}
                </a>
              </li>
              <li>{LOCATION}</li>
              <li>
                <a
                  href={WHATSAPP_LINK}
                  target="_blank"
                  rel="noreferrer"
                  className="text-[#25D366] hover:text-white inline-flex items-center gap-2"
                  data-testid="footer-whatsapp"
                >
                  WhatsApp directo →
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-white/5 flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-[#a0aabf]">
          <div className="font-mono">
            © {year} Transformadores Bucaramanga · Todos los derechos reservados
          </div>
          <div className="flex gap-6 font-mono uppercase tracking-wider">
            <span>RETIE Certificado</span>
            <span>·</span>
            <span>NTC 818 / 819</span>
            <span>·</span>
            <span>SST</span>
          </div>

          <a
            href="https://jakemate.click"
            target="_blank"
            rel="noreferrer"
            className="font-mono hover:text-white transition-colors"
            data-testid="footer-developed-by"
          >
            Desarrollado por Jake Mate
          </a>
        </div>
      </div>
    </footer>
  );
}
